import { render, staticRenderFns } from "./TotalRanking.vue?vue&type=template&id=8bb6ec52&"
import script from "./TotalRanking.vue?vue&type=script&lang=js&"
export * from "./TotalRanking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports